var indentation_default = {
  "indentZero": "bfpEf",
  "indentOne": "VEqR-",
  "indentTwo": "P7YWt",
  "indentThree": "tnHmY",
  "indentFour": "_7CD5p",
  "indentFive": "Bgbgr",
  "indentSix": "yHfQh"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
